/**
 * ChatWidget Module
 * 
 * This module provides a flexible chat widget that can be used across different projects.
 * 
 * Default export: Setup component with automatic authentication and environment detection
 * Named exports: 
 *   - ChatWidget: Core component that requires manual configuration
 *   - Setup: Wrapper component with automatic setup for current project
 */

import { Setup } from './Setup';

// Named exports for flexibility
export { ChatWidget } from './ChatWidget';

// Default export for easy usage in current project
export default Setup;
